import { useState } from "react";
import "../CSS/connect.scss";
import { usePageBackground } from "../COMPONENTS/usePageBackground";

interface Props {
  saving: boolean;
  error: string;
  onSave: (apiKey: string, athleteId: string) => void;
}

export function ConnectView({ saving, error, onSave }: Props) {
  usePageBackground();
  const [apiKey,    setApiKey]    = useState("");
  const [athleteId, setAthleteId] = useState("");

  const canSave = apiKey.trim().length > 0 && athleteId.trim().length > 0;

  return (
    <div className="connect">
      <div className="connect__card">
        <h1 className="connect__title">Koppla intervals.icu</h1>
        <p className="connect__subtitle">
          Ange dina uppgifter nedan. De lagras krypterat och används bara för att hämta din träningsdata.
        </p>

        <div className="connect__field">
          <label className="connect__label">API-nyckel</label>
          <input
            className="connect__input"
            type="password"
            placeholder="Klistra in din API-nyckel"
            value={apiKey}
            onChange={e => setApiKey(e.target.value)}
            autoComplete="off"
          />
          <p className="connect__hint">
            Finns i intervals.icu under <strong>Settings → API</strong> → "Copy API key"
          </p>
        </div>

        <div className="connect__field">
          <label className="connect__label">Athlete ID</label>
          <input
            className="connect__input"
            type="text"
            placeholder="t.ex. i12345"
            value={athleteId}
            onChange={e => setAthleteId(e.target.value)}
            autoComplete="off"
          />
          <p className="connect__hint">
            Syns i URL:en när du är inloggad: intervals.icu/athlete/<strong>i12345</strong>/calendar
          </p>
        </div>

        {error && <p className="connect__error">{error}</p>}

        <button
          className="connect__btn"
          disabled={!canSave || saving}
          onClick={() => onSave(apiKey.trim(), athleteId.trim())}
        >
          {saving ? "Sparar…" : "Spara och fortsätt"}
        </button>
      </div>
    </div>
  );
}
